import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import {  BasicInput, BasicTextArea, BaasicFormControls, BaasicButton, BasicFieldCheckbox, BaasicFieldDropdown } from 'core/components';
import { Content } from 'core/layouts';
import { emailRecipientLabels } from 'core/utils';
function FacilityAdditionalContactTemplate({ facilityAdditionalContactEditView , t}) {
    const {
        contentLoading,
        form,
        componentParams,
        addSave,
        isEdit,
        contactDepartmentStore,
    } = facilityAdditionalContactEditView;

    function renderEmailSettings(form, emailRecipientLabels) {
        return emailRecipientLabels.map(({ name, label }) => {
            const emailField = form.$(name);
    
            return (
                <div key={name} className="card--settings--inner">
                    <div className='btn--toggled__label'>{label}</div>
                    <div className='btn--toggled__wrap'>
                        {['To', 'CC', ''].map((val, index) => (
                            <button
                                key={index}
                                type="button"
                                className={`btn btn--toggled ${
                                    emailField.value === val ? 'btn--primary' : ''
                                }`}
                                onClick={() => emailField.set(val)}
                            >
                                {val === '' ? <i className="u-icon u-icon--sml u-icon--inactive--toggle"></i> : val}
                            </button>
                        ))}
                    </div>
                </div>
            );
        });
    }

    return (
        <React.Fragment>
            <Content loading={contentLoading} >
                <div className="modal__header">
                    <h3 className="modal__header__title">{isEdit ? "Edit": "Add"} contact</h3>
                </div>
                <div className="modal__body">
                    <div className="row row--form">
                        <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                            <BasicInput field={form.$('name')} />
                        </div>
                         <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                            <BasicInput field={form.$('lastName')} />
                        </div>
                        <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                            <BaasicFieldDropdown field={form.$('facilityAdditionalContactContactDepartments')} store={contactDepartmentStore} multi={true} autoClose={true} />
                        </div>
                    </div>
                    <div className="form__group">
                        <BasicInput field={form.$('email')} />
                    </div>
                     <div className="form__group">
                        <label className='form__group__label'>Include On</label>
                        <div className="u-mar--bottom--sml card card--settings">
                            {renderEmailSettings(form, emailRecipientLabels)}
                        </div> 
                    </div>
                    <div className="form__group">
                        <BasicTextArea field={form.$('note')} />
                    </div>
                </div>
            </Content>
        <div className="modal__footer is-right">
            {isEdit &&
                <div className="u-align--h--left">  
                    <BasicFieldCheckbox field={form.$('inActive')} />
                </div>
            }
            <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={form.submitting} label="Save"  className='btn btn--med btn--primary' />
            {!isEdit && <BaasicFormControls form={form} onSubmit={addSave} disabled={form.submitting} label="Save and Add"  className='btn btn--med btn--primary' /> }
            <BaasicButton
                 className='btn btn--med btn--light'
                label={t('EDIT_FORM_LAYOUT.CANCEL')}
                onClick={() => componentParams.modalParams.close()}
            />
        </div>
    </React.Fragment>
    )
}

FacilityAdditionalContactTemplate.propTypes = {
    facilityAdditionalContactEditView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityAdditionalContactTemplate);
